import { render, staticRenderFns } from "./dictHeader.vue?vue&type=template&id=cff45c70&scoped=true&lang=pug&"
import script from "./dictHeader.vue?vue&type=script&lang=js&"
export * from "./dictHeader.vue?vue&type=script&lang=js&"
import style0 from "./dictHeader.vue?vue&type=style&index=0&id=cff45c70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff45c70",
  null
  
)

export default component.exports